import { render, staticRenderFns } from "./PaymentFeedbackForm.vue?vue&type=template&id=044c731a&scoped=true"
import script from "./PaymentFeedbackForm.vue?vue&type=script&lang=js"
export * from "./PaymentFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentFeedbackForm.vue?vue&type=style&index=0&id=044c731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c731a",
  null
  
)

export default component.exports